<div class="privacy">
  <div class="shadow"></div>

  <div class="video">
    <video loop autoplay #videoBackground [muted]="true">
      <source
        src="https://d2z7yiz3wla4oq.cloudfront.net/videos/ride-run.mp4"
        type="video/mp4" />
      Sorry, your browser doesn't support embedded videos.
    </video>
  </div>
  <!-- English Part -->
  <div *ngIf="isEnglish" class="container-fluid content mb-5">
    <h1 class="mt-3 text-center">Kinomap Privacy Policy</h1>
    <div class="alert alert-warning mt-5" role="alert">
      Updated May 25th: please read
      <a
        href="https://support.kinomap.com/hc/en-us/articles/360000860266"
        target="_blank"
        rel="noopener noreferrer">
        this article
      </a>
      for an overview of how your data is handled
    </div>
    <div class="alert alert-warning pt-0" role="alert">
      The items below concern the Kinomap platform, the Kinomap application and
      the Tunturi Routes application.
    </div>
    <ul class="list-group text-justify">
      <h2 class="mt-2">1 - Our Commitment To Privacy:</h2>
      <li class="list-group-item">
        <p>
          Your privacy is important to us. To secure your privacy, we provide
          this explaining text on our website in order for you to make the best
          choices about the way your information is collected and used by us
          (the "Privacy Policy").
        </p>
        <p>
          To make this Privacy Policy easy to access, we make it available on
          our home page and through a link on our login page. If the Privacy
          Policy changes, we will attempt to notify you via the email address
          you have provided.
        </p>
        <p>
          The Privacy Policy has been in effect since the launch of the platform
          on January 1, 2010 and the release of the first applications on
          January 1, 2013. Please note that this Privacy Policy covers your use
          of the website located at
          <a href="/">www.kinomap.com</a>
          and its affiliated sites (the "Site"), whether you are a Registered
          User or not, as well as your use of the Kinomap Uploader web services
          (the "Uploader") and the Kinomap application (the "Application").
        </p>
        <p>
          The Privacy Policy does not identify the policies of third party web
          pages that you may access separately through the Site (for example,
          online mobile application delivery platforms, Facebook, Twitter or
          YouTube). Please check the policies of these companies or sources to
          determine how they handle your private information.
        </p>
      </li>

      <h2 class="mt-5">2 - The Information We Collect and How We Use It.</h2>
      <li class="list-group-item">
        <p>
          The Privacy Policy applies to all information that may be collected or
          submitted on the Site or in connection with your use of the Site. When
          you register as a user on the Site to access all features of the Site
          available only to registered users, you are required to provide us
          with the following information:
        </p>
        <ul>
          <li>Email Address</li>
          <li>User Name</li>
          <li>Password</li>
          <li>Confirmation Password</li>
        </ul>
        <p>You may also provide if you wish:</p>
        <ul>
          <li>Your last name and first name</li>
          <li>Your phone number</li>
          <li>Your address</li>
          <li>Your gender</li>
          <li>Your weight</li>
          <li>Your age</li>
          <li>Your height</li>
          <li>Your date of birth</li>
          <li>Your pace</li>
          <li>Your heart rate</li>
          <li>Your speed</li>
          <li>Your altitude progress</li>
          <li>The equipment you use</li>
        </ul>
        <p>
          When you register to use the Site using the Register via Facebook,
          Strava or similar platform link, you must provide your Facebook
          username and password to log in to the Site. In this case, we have
          access to your basic Facebook user information, including your
          username, name email address, gender, date of birth, current city,
          profile picture, URL, and the credentials of the user's friends who
          also joined Kinomap through the platform used to create the account
          and log in.
        </p>

        <!-- Paris 2024 Privacy - EN -->
        <p>
          We share your data with the International Olympic Committee
          (Switzerland) (“IOC”), the Paris Organising Committee for the Olympic
          and Paralympic Games 2024 (France) (“Paris 2024”), and the Los Angeles
          Organising Committee for the Olympic and Paralympic Games 2028 (USA)
          (“LA 2028”). Your data will be used by each of the IOC, Paris 2024 and
          LA 2028 as separate data controllers, to better understand their fans,
          evaluate the performance of digital properties or activities connected
          to the Olympic Games or Paralympic Games, personalise their services,
          products and marketing activities and, where you have given your
          consent, send you direct marketing, including marketing related to
          their products, services and partners. The sharing of data described
          in this sub-paragraph is based on consent (where you have provided it)
          or each of the IOC’s, Paris 2024’s or LA 2028’s legitimate interest to
          fulfil the purposes described here. Subject to some exceptions, you
          have the right to object to such processing activities. For more
          information about how these organisations use your data, as well as
          how you can assert your data subject rights with each of them, please
          see their privacy policies here:
        </p>

        <ul>
          <li><a href="https://olympics.com/en/privacy-policy">IOC</a></li>
          <li>
            <a href="https://www.paris2024.org/fr/politique-confidentialite/"
              >Paris 2024</a
            >
          </li>
          <li>
            <a href="https://la28.org/en/footer-links/privacy-policy.html"
              >LA 2028</a
            >
          </li>
        </ul>

        <p>
          On some pages, you may send us requests or correspond with us (for
          example, when you submit a question via the automated form available
          on the Contact Us page of the Site or via the Comments tab of the
          Site). The types of personal information you must provide for general
          inquiries and support are as follows:
        </p>
        <ul>
          <li>First and Last Name</li>
          <li>Email Address</li>
        </ul>
        <p>
          We will also collect any other information that you include in the
          body or subject line of your message to us including information about
          how we can contact you to respond to your request. Such information
          may include your phone number or mailing address. You may provide a
          take down notice to us for content that you believe is infringing your
          copyrights as described under Copyright Violations in the Website
          Terms of Use. A take down notice must provide to us all of the
          information required by the Digital Millennium Copyright Act. That
          information includes the following personal information:
        </p>
        <ul>
          <li>First and Last Name</li>
          <li>Physical Address</li>
          <li>Telephone Number</li>
          <li>Email Address</li>
        </ul>
        <p>
          When you use the Uploader from your computer to upload videos to
          Kinomap, you authorize us to collect your Kinomap username, the mode
          of transport used in the video, the time and date you upload the video
          to the site, the geographic location from which the video was
          uploaded, the geographic location, time and date the video was filmed,
          including the start and end points, the duration of the video and
          specific GPS location information for the entire video footage. GPS
          information includes location, speed, distance and elevation.
        </p>
        <p>
          We use this data in connection with your video(s) to create content
          for the Site and the Application. We make this data available to other
          users of the Site, both registered and unregistered, and to users of
          the Kinomap Training Application.
        </p>
        <p>
          We provide a license of the Training Application to some fitness
          equipment manufacturers. The data associated with the videos and the
          videos are shared with these equipment manufacturers as part of the
          license for the Training Application.
        </p>
        <p>
          Users of the Site may share videos with others via third party
          websites, such as Facebook, YouTube, Twitter and blog sites. When a
          video is shared or linked to another site, the information you
          provided about the video is included in the video and becomes
          available to users of those third-party websites.
        </p>
        <p>
          We also provide this data to our advertisers on the Site and on the
          Kinomap training application for the purpose of targeting advertising
          to our site users.
        </p>
        <p>
          We also aggregate data from all videos uploaded to the Site for search
          and filtering functions on the Site and Kinomap Training App, for
          internal research, product and service development, marketing and
          targeted advertising purposes, and quality control.
        </p>
        <p>
          In addition, we may share or sell the anonymized aggregate data we
          collect, including geographic location data, with outside third
          parties. You may change, delete and manage your information collected
          by Kinomap by emailing
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>
          .
        </p>
        <p>
          <u>Cookies.</u>
          We may also collect information about how you access the Site using
          cookies. Session identification cookies may be used by us to track
          your preferences when you visit the Site. They also help minimize
          loading times and save on server processing. Persistent cookies may be
          used by us to record whether, for example, you want your password to
          be remembered or not. The cookies used on the Site do not contain your
          personal information. For a detailed explanation of our cookie policy,
          please visit
          <a href="/cookies">Cookies Policy.</a>
        </p>
        <p>
          <u>Log Files.</u>
          We use log files that may include Internet Protocol (IP) addresses,
          browser type, Internet Service Provider (ISP), referring/exit pages,
          platform type, time stamp, geographic location, number of clicks, page
          views and video views to analyze trends, administer the Site and
          gather broad demographic information for aggregate use. However, none
          of this information contains any personal information.
        </p>
        <p>
          <u>Information You Provide.</u>
          We primarily use the personal information you provide during
          registration to complete registration, to check your connections to
          the Site, to facilitate the upload of the Downloader, the Application
          and your use of the Downloader and the Application.
        </p>
        <p>
          Your username will be used to identify the videos you upload to the
          Site and to identify you as a user of the Site for all other activity
          on the Site, including when you provide comments on videos.
        </p>
        <p>
          Except for information you make public through the content you post on
          the Site, we use commercially reasonable means to protect the
          personally identifiable information you provide to us during the
          registration process and we will not share, sell, or disseminate the
          personal data to others, except as authorized by you, as required by
          law, as necessary to enforce the Terms of Use and End User License
          Agreements, or to protect the rights, property or safety of us, our
          employees, agents, representatives and affiliates, our users or
          others.
        </p>
        <p>
          For example, we may disclose information we collect about you,
          including personally identifiable information, to law enforcement or
          other government agencies if we receive a subpoena, search warrant,
          summons, or other court order and the information is necessary to
          protect others from injury, serious harm, or death; to prevent fraud;
          or to assist in the investigation of a crime or threat of a serious
          crime or suspected terrorist activity.
        </p>
        <p>
          We use return email addresses and your name to respond to emails we
          receive.
        </p>
        <p>
          As part of your registration to use the Site or Application, you have
          also authorized us to communicate with you regarding updates, bug
          fixes and/or enhancements to the Site, Downloader or Training
          Applications that you have downloaded, changes to the Terms of Use, or
          violations we identify or concerns we have related to your use of the
          Site, Downloader or Training Applications.
        </p>
        <p>
          We may also use your e-mail address to send you promotional or
          marketing e-mails about us and our products and services. You may
          opt-out by contacting us and requesting to be removed from the list at
          www.kinomap.com or by following the opt-out link provided in the email
          we send you.
        </p>
        <p>
          It could be necessary to send a strictly service-related announcement,
          if, for example, our service is temporarily suspended for maintenance.
          In general, you may not opt out of these communications, but you may
          cancel or terminate your registration. However, these communications
          are not promotional in nature. Your email address is not used for any
          other purpose and is not shared with any third parties.
        </p>
        <p>
          We may use and disclose non-identifying and aggregate information to
          better design our website and share it with potential advertisers and
          investors. For example, we may tell an advertiser that X number of
          individuals have viewed a video, the geographic location of the video,
          and the geographic location of the users who have viewed the video,
          but we will not disclose anything that can be used to directly
          identify an individual; provided, however, that if you use your real
          name for your Kinomap username, your name may be shared with potential
          advertisers and investors with respect to content you share or post on
          the site. You can opt-out by changing your username.
        </p>
        <p>
          In the event of a sale of Kinomap, any of its divisions, or its
          software and technology, information collected from users may be
          transferred to the new owners. We may also share the information we
          collect with our affiliates. Finally, we do not use or share
          personally identifiable information provided to us in ways unrelated
          to the ones described above without giving you the opportunity to
          opt-out. You may edit, delete and manage your information collected by
          Kinomap by emailing
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com.</a>
        </p>
      </li>

      <h2 class="mt-5">3. Our commitment to data security:</h2>
      <li class="list-group-item">
        <p>
          In order to prevent unauthorized access, maintain data accuracy, and
          ensure the correct use of information, we have put in place
          commercially reasonable physical, electronic, and managerial
          procedures to secure the information we may collect online.
        </p>
        <p>
          If we become aware of any particular risk or vulnerability to the
          security of information we have collected from users, we will notify
          you using the email address you have provided.
        </p>
      </li>

      <h2 class="mt-5">4. Our Commitment to Children's Privacy:</h2>
      <li class="list-group-item">
        <p>
          Protecting the privacy of younger children is essential. For this
          reason, we do not collect or maintain information on our Site from
          anyone we know to be under the age of 13, and no part of our website
          is structured to attract anyone under the age of 13.
        </p>
        <p>
          You may not register to use the Site, Downloader or Training
          Applications if you are under 13 years old.
        </p>
      </li>

      <h2 class="mt-5">
        5. How you can access, correct or delete your information:
      </h2>
      <li class="list-group-item">
        <p>
          We use your email address and username to facilitate your use of the
          Site, your loading of the Downloader and/or Training Applications, to
          check your login, to respond to your email requests or other
          communications with us, and to provide you with information regarding
          upgrades, bug fixes and/or enhancements to the Site, Downloader or
          Application, potential security risks, or other promotional
          information about us, as noted above.
        </p>
        <p>
          You may access and update your user information by logging into your
          user account. If your name, email address, or other user information
          changes and you would like to continue receiving this information,
          please contact us at
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>
        </p>
        <p>
          To protect your privacy and security, and to prevent misuse of our
          software, we may take reasonable steps to verify your identity before
          authorizing or implementing any such change.
        </p>
        <p>
          <u>Opting Out.</u>
          If you no longer wish us to collect, store or use your information,
          you must stop using the Site, Downloader and Training Applications,
          cancel your user account and send us a message at
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>
          requesting that we remove your information from our database.
          Withdrawing your consent does not affect the lawfulness of the
          processing prior to the withdrawal.
        </p>
        <p>
          We will use commercially reasonable means to delete your information
          within a reasonable period of time after receiving your request, as
          long as you have cancelled your account and stopped using the Site,
          Downloader and Training Applications; however, certain non-personally
          identifiable information or aggregate data we have collected from you
          may not be deleted. You have the ability to delete videos and other
          content that you post or share on the Site.
        </p>
        <p>
          <u>Termination.</u>
          Once your subscription is terminated, all data in your account will be
          deleted within one year of your termination.
        </p>
        <p>
          <u>Your Rights.</u>
          Personal data is any information relating to a natural person who can
          be identified, directly or indirectly.
        </p>
        <p>
          Under current data protection legislation, you have the following
          rights:
        </p>
        <ul>
          <li>
            <u>Right of access.</u>
            You can obtain confirmation of the processing of your data collected
            by KINOMAP, access to its data, as well as for example the purposes
            of the processing, or the categories of data concerned.
          </li>
          <li>
            <u>Right of rectification.</u>
            You can request the rectification of your data if they are
            inaccurate.
          </li>
          <li>
            <u>Right to erase.</u>
            You may request the deletion of your data, in particular if the data
            has been processed unlawfully or if the purpose for which it was
            collected is no longer relevant.
          </li>
          <li>
            <u>Right to restrict processing.</u>
            You have the right to restrict the processing of your personal data
            in certain circumstances.
          </li>
          <li>
            <u>Right to data portability.</u>
            You have the right to receive your personal data in a structured,
            common and machine-readable format and to transfer it to another
            organization if this is technically feasible.
          </li>
          <li>
            <u>Right to object.</u>
            You may object at any time to the processing of your personal data
            for reasons relating to your particular situation or, for example,
            if your data is used for protection purposes.
          </li>
        </ul>
      </li>

      <h2 class="mt-5">6. How to contact us:</h2>
      <li class="list-group-item">
        <p>
          If you have any further questions or concerns about these privacy
          policies, please contact us at
          <a href="support@kinomap.com">support&#64;kinomap.com</a>
        </p>
      </li>
    </ul>
  </div>

  <!-- French Part -->
  <div *ngIf="!isEnglish" class="container-fluid content mb-5">
    <h1 class="mt-3 text-center">Politique de Confidentialité Kinomap</h1>
    <div class="alert alert-warning mt-5" role="alert">
      Mise à jour le 17 août 2021 : veuillez lire
      <a
        href="https://support.kinomap.com/hc/en-us/articles/360000860266"
        target="_blank"
        rel="noopener noreferrer">
        cet article
      </a>
      pour un aperçu de la façon dont vos données sont traitées
    </div>
    <div class="alert alert-warning pt-0" role="alert">
      Les éléments ci-dessous concernent la plateforme Kinomap, l’application
      Kinomap ainsi que l’application Tunturi Routes.
    </div>
    <ul class="list-group text-justify">
      <h2 class="mt-2">1. Notre engagement envers la confidentialité :</h2>
      <li class="list-group-item">
        <p>
          Votre vie privée est importante pour nous. Pour mieux protéger votre
          vie privée, nous fournissons cet avis expliquant nos pratiques
          d'information en ligne et les choix que vous pouvez faire sur la façon
          dont vos informations sont collectées et utilisées par nous (la
          "Politique de confidentialité").
        </p>

        <p>
          Pour que cet avis soit facile à trouver, nous le mettons à disposition
          sur notre page d'accueil et par le biais d'un lien sur notre page de
          connexion. En cas de modification de la Politique de confidentialité,
          nous tenterons de vous informer par le biais de l'adresse électronique
          que vous nous avez fournie.
        </p>
        <p>
          La Politique de confidentialité est en vigueur depuis le lancement de
          la plateforme le 1er janvier 2010 et la publication des premières
          applications dès le 1er janvier 2013. Veuillez noter que la présente
          Politique de confidentialité concerne votre utilisation du site Web
          situé à l'adresse
          <a href="/">www.kinomap.com</a>
          et de ses sites affiliés (le " Site "), que vous soyez un Utilisateur
          enregistré ou non, ainsi que votre utilisation des services Web de
          Kinomap Uploader (l'" Uploader ") et de l’application Kinomap
          (l’”Application”).
        </p>
        <p>
          La Politique de confidentialité n'identifie pas les politiques des
          pages web de tiers auxquelles vous pouvez accéder séparément par le
          biais du site (par exemple, les plateformes de diffusion d’
          d'applications mobiles en ligne, Facebook, Twitter ou YouTube).
          Veuillez consulter les politiques de ces sociétés ou sources pour
          déterminer comment elles traitent vos informations privées.
        </p>
      </li>

      <h2 class="mt-5">
        2. Les informations que nous recueillons et comment nous les utilisons :
      </h2>
      <li class="list-group-item">
        <p>
          La Politique de confidentialité s'applique à toutes les informations
          qui peuvent être collectées ou soumises sur le site ou dans le cadre
          de votre utilisation du Site. Lorsque vous vous inscrivez en tant
          qu'utilisateur sur le Site pour accéder à toutes les fonctions du Site
          accessibles uniquement aux utilisateurs inscrits, vous êtes tenu de
          nous fournir les informations suivantes :
        </p>
        <ul>
          <li>Adresse électronique</li>
          <li>Nom d'utilisateur</li>
          <li>Mot de passe</li>
          <li>Mot de passe de confirmation</li>
        </ul>
        <p>Vous pouvez également fournir si vous le souhaitez :</p>
        <ul>
          <li>Votre nom de famille et prénom</li>
          <li>Votre numéro de téléphone</li>
          <li>Votre adresse postale</li>
          <li>Votre genre</li>
          <li>Votre poids</li>
          <li>Votre âge</li>
          <li>Votre taille</li>
          <li>Votre date de naissance</li>
          <li>Votre allure</li>
          <li>Votre rythme cardiaque</li>
          <li>Votre vitesse</li>
          <li>Votre progression en altitude</li>
          <li>L’équipement que vous utilisez</li>
        </ul>
        <p>
          Lorsque vous vous inscrivez pour utiliser le site en utilisant le lien
          S'inscrire via Facebook, Strava ou tout autre plateforme similaire,
          vous devez fournir votre nom d'utilisateur et votre mot de passe
          Facebook pour vous connecter au site. Dans ce cas, nous avons accès à
          vos informations de base d'utilisateur de Facebook, notamment votre
          identifiant, votre nom, votre adresse électronique, votre sexe, votre
          date de naissance, votre ville actuelle, votre photo de profil, votre
          URL et les identifiants des amis de l'utilisateur qui ont également
          rejoint Kinomap par l'intermédiaire de la plateforme ayant servi à la
          création du compte et à la connexion.
        </p>

        <!-- Paris 2024 Privacy - FR -->
        <p>
          Nous partageons vos données avec le Comité international olympique
          (Suisse) ("CIO"), le Comité d'organisation de Paris pour les Jeux
          Olympiques et olympiques et paralympiques 2024 (France) ("Paris
          2024"), et le Comité d'organisation des d'organisation des Jeux
          olympiques et paralympiques de 2028 à Los Angeles (États-Unis) ("LA
          2028"). Vos données seront utilisées par le CIO, Paris 2024 et LA 2028
          en tant que responsables du traitement distincts. LA 2028 en tant que
          contrôleurs de données distincts, afin de mieux comprendre leurs fans,
          évaluer la performance des propriétés ou activités numériques liées
          aux aux Jeux Olympiques ou aux Jeux Paralympiques, personnaliser leurs
          services, services, produits et activités de marketing et, si vous
          avez donné votre marketing direct, y compris le marketing lié à leurs
          produits, services et partenaires. leurs produits, services et
          partenaires. Le partage des données décrit dans ce sous-paragraphe est
          basé sur le consentement (lorsque vous l'avez donné) ou l'intérêt
          légitime du CIO, de Paris 2024 ou de LA 2028 à remplir les objectifs
          décrits ici. Sous réserve de certaines exceptions, vous avez le droit
          de vous opposer à ces activités de traitement. Pour plus
          d'informations sur la manière dont ces organisations utilisent vos
          données, veuillez consulter le site web du CIO. informations sur la
          manière dont ces organisations utilisent vos données, ainsi que
          comment vous pouvez faire valoir vos droits de personne concernée
          auprès de chacune d'entre elles, veuillez consulter leurs politiques
          de confidentialité ici :
        </p>

        <ul>
          <li><a href="https://olympics.com/en/privacy-policy">IOC</a></li>
          <li>
            <a href="https://www.paris2024.org/fr/politique-confidentialite/"
              >Paris 2024</a
            >
          </li>
          <li>
            <a href="https://la28.org/en/footer-links/privacy-policy.html"
              >LA 2028</a
            >
          </li>
        </ul>

        <p>
          Sur certaines pages, vous pouvez nous adresser des demandes ou
          correspondre avec nous (par exemple, lorsque vous nous soumettez une
          question via le formulaire automatisé disponible sur la page
          Contactez-nous du site ou via l'onglet Commentaires du site). Les
          types d'informations personnelles que vous devez fournir pour les
          demandes d'informations générales et l'assistance sont les suivants :
        </p>
        <ul>
          <li>Nom et prénom</li>
          <li>Adresse électronique</li>
        </ul>
        <p>
          Nous collecterons également toute autre information que vous incluez
          dans le corps ou l'objet de votre message, y compris des informations
          sur la manière dont nous pouvons vous contacter pour répondre à votre
          demande. Ces informations peuvent inclure votre numéro de téléphone ou
          votre adresse postale. Vous pouvez nous fournir un avis de retrait
          pour le contenu qui, selon vous, enfreint vos droits d'auteur, comme
          décrit dans la section Violations des droits d'auteur des conditions
          d'utilisation du site Web. Un avis de retrait doit nous fournir toutes
          les informations requises par le Digital Millennium Copyright Act. Ces
          informations comprennent les renseignements personnels suivants :
        </p>
        <ul>
          <li>Nom et prénom</li>
          <li>Adresse physique</li>
          <li>Numéro de téléphone</li>
          <li>Adresse électronique</li>
        </ul>
        <p>
          Lorsque vous utilisez l'Uploader à partir de votre ordinateur pour
          télécharger des vidéos sur Kinomap, vous nous autorisez à collecter
          votre nom d'utilisateur Kinomap, le mode de transport utilisé dans la
          vidéo, l'heure et la date auxquelles vous téléchargez la vidéo sur le
          site, l'emplacement géographique à partir duquel la vidéo a été
          téléchargée, l'emplacement géographique, l'heure et la date auxquels
          la vidéo a été filmée, y compris les points de départ et d'arrivée, la
          durée de la vidéo et les informations de localisation GPS spécifiques
          pour l'ensemble du métrage vidéo. Les informations GPS comprennent la
          localisation, la vitesse, la distance et l'élévation.
        </p>
        <p>
          Nous accordons une licence pour l'application de formation à certains
          fabricants d'équipements de fitness. Les données associées aux vidéos
          et les vidéos sont partagées avec ces fabricants d'équipements dans le
          cadre de la licence de l'Application de formation.
        </p>
        <p>
          Les utilisateurs du Site peuvent partager les vidéos avec d'autres
          personnes via des sites web tiers, tels que Facebook, YouTube, Twitter
          et des sites de blog. Lorsqu'une vidéo est partagée ou liée à un autre
          site, les informations que vous avez fournies sur la vidéo sont
          incluses dans la vidéo et deviennent accessibles aux utilisateurs de
          ces sites web tiers.
        </p>
        <p>
          Nous fournissons également ces données à nos annonceurs sur le site et
          sur l'application de formation Kinomap dans le but de cibler la
          publicité sur les utilisateurs de notre site.
        </p>
        <p>
          Nous regroupons également les données de toutes les vidéos
          téléchargées sur le Site pour les fonctions de recherche et de
          filtrage sur le Site et l'Application de formation Kinomap, pour la
          recherche interne, le développement de produits et de services, à des
          fins de marketing et de publicité ciblée et de contrôle de la qualité.
        </p>
        <p>
          En outre, nous pouvons partager ou vendre les données globales
          anonymisées que nous collectons, y compris les données de localisation
          géographique, avec des tiers extérieurs. Vous pouvez modifier,
          supprimer et gérer vos informations recueillies par Kinomap en
          adressant un courriel à
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>
          .
        </p>
        <p>
          <u>Cookies.</u>
          Nous pouvons également collecter des informations sur la manière dont
          vous accédez au Site à l'aide de cookies. Les cookies d'identification
          de session peuvent être utilisés par nous pour suivre vos préférences
          lorsque vous visitez le Site. Ils permettent également de minimiser
          les temps de chargement et d'économiser sur le traitement du serveur.
          Les cookies persistants peuvent être utilisés par nous pour
          enregistrer si, par exemple, vous souhaitez que votre mot de passe
          soit mémorisé ou non. Les cookies utilisés sur le Site ne contiennent
          pas vos informations personnelles. Pour connaître notre politique de
          cookies en détail :
          <a href="/cookies">Politique de Cookies Kinomap</a>
          .
        </p>
        <p>
          <u>Fichiers journaux.</u>
          Nous utilisons des fichiers journaux qui peuvent inclure les adresses
          de protocole Internet (IP), le type de navigateur, le fournisseur
          d'accès Internet (FAI), les pages de renvoi/de sortie, le type de
          plate-forme, l'horodatage, l'emplacement géographique, le nombre de
          clics, de pages vues et de vidéos vues pour analyser les tendances,
          administrer le Site et recueillir des informations démographiques
          générales pour une utilisation globale. Toutefois, aucune de ces
          informations ne contient de renseignements personnels.
        </p>
        <p>
          <u>Informations que vous fournissez.</u>
          Nous utilisons principalement les informations que vous fournissez à
          votre sujet lors de l'inscription pour compléter l'inscription, pour
          vérifier vos connexions au Site, pour faciliter le téléchargement du
          Téléchargeur, de l’Application et votre utilisation du Téléchargeur et
          de l’Applications.
        </p>
        <p>
          Votre nom d'utilisateur sera utilisé pour identifier les vidéos que
          vous téléchargez sur le Site et pour vous identifier en tant
          qu'utilisateur du Site pour toute autre activité sur le Site, y
          compris lorsque vous fournissez des commentaires sur les vidéos.
        </p>
        <p>
          À l'exception des informations que vous avez rendues publiques par le
          biais du contenu que vous publiez sur le Site, nous utilisons des
          moyens commercialement raisonnables pour protéger les informations
          d'identification personnelle que vous nous avez fournies au cours du
          processus d'enregistrement et nous ne partagerons, ne vendrons ni ne
          diffuserons les données personnelles à d'autres personnes, sauf si
          vous l'autorisez, si la loi nous y oblige, si cela est nécessaire pour
          faire respecter les Conditions d'utilisation et les Contrats de
          licence d'utilisateur final, ou pour protéger nos droits, notre
          propriété ou notre sécurité, celle de nos employés, agents,
          représentants et affiliés, celle de nos utilisateurs ou d'autres
          personnes.
        </p>
        <p>
          Par exemple, nous pouvons divulguer les informations que nous
          recueillons à votre sujet, y compris les informations permettant de
          vous identifier personnellement, à des organismes d'application de la
          loi ou à d'autres organismes gouvernementaux si nous recevons une
          assignation, un mandat de perquisition, une citation à comparaître ou
          toute autre décision de justice et que ces informations sont
          nécessaires pour protéger d'autres personnes contre des blessures, des
          dommages graves ou la mort, pour prévenir la fraude ou pour aider à
          l'enquête sur un crime ou une menace de crime grave ou une activité
          terroriste présumée.
        </p>
        <p>
          Nous utilisons les adresses e-mail de retour et votre nom pour
          répondre aux e-mails que nous recevons.
        </p>
        <p>
          Dans le cadre de votre inscription pour utiliser le Site ou
          l’Application, vous nous avez également autorisés à communiquer avec
          vous concernant les mises à jour, les corrections de bogues et/ou les
          améliorations du Site, du Téléchargeur ou des Applications de
          formation que vous avez téléchargées, les modifications des Conditions
          d'utilisation, ou les violations que nous identifions ou les
          préoccupations que nous avons liées à votre utilisation du Site, du
          Téléchargeur ou des Applications de formation.
        </p>
        <p>
          Nous pouvons également utiliser votre adresse électronique pour vous
          envoyer des courriels promotionnels ou de marketing sur nous et nos
          produits et services. Vous pouvez refuser de recevoir ces courriels
          promotionnels en nous contactant et en demandant à être retiré de la
          liste à l'adresse
          <a href="/">www.kinomap.com</a>
          ou en suivant le lien d'exclusion fourni dans le courriel que nous
          vous envoyons.
        </p>
        <p>
          En de rares occasions, il est nécessaire d'envoyer une annonce
          strictement liée au service, si, par exemple, notre service est
          temporairement suspendu pour maintenance. En général, vous ne pouvez
          pas refuser ces communications, mais vous pouvez annuler ou résilier
          votre inscription. Toutefois, ces communications ne sont pas de nature
          promotionnelle. Votre adresse électronique n'est pas utilisée à
          d'autres fins et n'est pas partagée avec des tiers.
        </p>
        <p>
          Nous pouvons utiliser et divulguer des informations non identifiantes
          et globales pour mieux concevoir notre site Web et les partager avec
          des annonceurs et des investisseurs potentiels. Par exemple, nous
          pouvons dire à un annonceur qu'un nombre X d'individus ont visionné
          une vidéo, l'emplacement géographique de la vidéo et l'emplacement
          géographique des utilisateurs qui ont visionné la vidéo, mais nous ne
          divulguerons rien qui puisse être utilisé pour identifier directement
          un individu ; à condition toutefois que si vous utilisez votre nom
          réel pour votre nom d'utilisateur Kinomap, votre nom peut être partagé
          avec des annonceurs et des investisseurs potentiels en ce qui concerne
          le contenu que vous partagez ou publiez sur le site. Vous pouvez vous
          désengager en modifiant votre nom d'utilisateur.
        </p>
        <p>
          En cas de vente de Kinomap, d'une de ses divisions ou de ses logiciels
          et technologies, les informations recueillies auprès des utilisateurs
          peuvent être transférées aux nouveaux propriétaires. Nous pouvons
          également partager les informations que nous recueillons avec nos
          sociétés affiliées. Enfin, nous n'utilisons ni ne partageons les
          informations personnellement identifiables qui nous sont fournies
          d'une manière qui n'est pas liée à celles décrites ci-dessus sans vous
          donner la possibilité de refuser. Vous pouvez modifier, supprimer et
          gérer vos informations recueillies par Kinomap en adressant un
          courriel à
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com.</a>
        </p>
      </li>

      <h2 class="mt-5">3. Notre engagement envers la sécurité des données :</h2>
      <li class="list-group-item">
        <p>
          Afin d'empêcher tout accès non autorisé, de maintenir l'exactitude des
          données et de garantir l'utilisation correcte des informations, nous
          avons mis en place des procédures physiques, électroniques et de
          gestion commercialement raisonnables pour sauvegarder et sécuriser les
          informations que nous pouvons recueillir en ligne.
        </p>
        <p>
          Si nous prenons conscience d'un risque particulier ou d’une faille
          pour la sécurité des informations que nous avons recueillies auprès
          des utilisateurs, nous vous en informerons en utilisant l'adresse
          électronique que vous nous avez fournie.
        </p>
      </li>

      <h2 class="mt-5">
        4. Notre engagement envers la vie privée des enfants :
      </h2>
      <li class="list-group-item">
        <p>
          La protection de la vie privée des plus jeunes est particulièrement
          importante. Pour cette raison, nous ne recueillons ni ne conservons
          sur notre Site des informations provenant de personnes dont nous
          savons qu'elles ont moins de 13 ans, et aucune partie de notre site
          Web n'est structurée pour attirer des personnes de moins de 13 ans.
        </p>
        <p>
          Vous ne pouvez pas vous inscrire pour utiliser le Site, le
          Téléchargeur ou les Applications de formation si vous avez moins de 13
          ans.
        </p>
      </li>

      <h2 class="mt-5">
        5. Comment vous pouvez accéder, corriger ou supprimer vos informations :
      </h2>
      <li class="list-group-item">
        <p>
          Nous utilisons votre adresse e-mail et votre nom d'utilisateur pour
          faciliter votre utilisation du Site, votre téléchargement du
          Téléchargeur et/ou des Applications de formation, vérifier votre
          connexion, répondre à vos demandes par e-mail ou à d'autres
          communications avec nous, et pour vous fournir des informations
          concernant les mises à niveau, les corrections de beugs et/ou les
          améliorations du Site, du Téléchargeur ou de l’Application, les
          risques de sécurité potentiels ou d'autres informations
          promotionnelles nous concernant, comme indiqué précédemment.
        </p>
        <p>
          Vous pouvez accéder à vos informations d'utilisateur et les mettre à
          jour en vous connectant à votre compte d'utilisateur. Si votre nom,
          votre adresse électronique ou d'autres informations d'utilisateur
          changent et que vous souhaitez continuer à recevoir ces informations,
          veuillez nous contacter à l'adresse
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>
        </p>
        <p>
          Pour protéger votre vie privée et votre sécurité, et pour éviter tout
          détournement de notre logiciel, nous pouvons prendre des mesures
          raisonnables pour vérifier votre identité avant d'autoriser ou de
          mettre en œuvre un tel changement.
        </p>
        <p>
          <u>Retrait.</u>
          Si vous ne souhaitez plus que nous recueillions, stockions ou
          utilisions vos informations, vous devez cesser d'utiliser le Site, le
          Téléchargeur et les Applications de formation, annuler votre compte
          utilisateur et nous envoyer un message à l'adresse
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>
          pour nous demander de supprimer vos informations de notre base de
          données. Le retrait de votre consentement n’affecte pas la licéité du
          traitement avant le retrait.
        </p>
        <p>
          Nous utiliserons des moyens commercialement raisonnables pour
          supprimer vos informations dans un délai raisonnable à compter de la
          réception de votre demande, tant que vous aurez annulé votre compte et
          cessé d'utiliser le Site, le Téléchargeur et les Applications de
          formation ; toutefois, certaines informations ou données agrégées non
          personnellement identifiables que nous avons recueillies auprès de
          vous peuvent ne pas être supprimées. Vous avez la possibilité de
          supprimer les vidéos et autres contenus que vous publiez ou partagez
          sur le Site.
        </p>
        <p>
          <u>Résiliation.</u>
          Une fois votre abonnement résilié, toutes les données de votre compte
          seront supprimées intégralement dans l’année suivant votre
          résiliation.
        </p>
        <p>
          <u>Vos droits.</u>
          Une donnée personnelle, c'est toute information relative à une
          personne physique susceptible d'être identifiée, directement ou
          indirectement.
          <a
            href="https://www.cnil.fr/fr/cnil-direct/question/une-donnee-caractere-personnel-cest-quoi"
            target="_blank"
            rel="noopener noreferrer">
            (donnée personnel)
          </a>
        </p>
        <p>
          Une donnée personnelle, c'est toute information relative à une
          personne physique susceptible d'être identifiée, directement ou
          indirectement.
        </p>
        <p>
          En vertu de la législation sur la protection des données en vigueur,
          vous disposez des droits suivant
          <a
            href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#:~:text=Rectification%20et%20effacement-,Article%2016%20%2D%20Droit%20de%20rectification,la%20concernant%20qui%20sont%20inexactes"
            target="_blank"
            rel="noopener noreferrer">
            (droits suivants)
          </a>
          :
        </p>
        <ul>
          <li>
            <u>Droit d’accès.</u>
            Vous pouvez obtenir la confirmation du traitement de vos données
            collectées par KINOMAP, l’accès à ses données, ainsi que par exemple
            les finalités du traitement, ou les catégories de données
            concernées.
          </li>
          <li>
            <u>Droit de rectification.</u>
            Vous pouvez demander la rectification de vos données lorsque
            celles-ci sont inexactes.
          </li>
          <li>
            <u>Droit à l’effacement.</u>
            Vous pouvez demander la suppression de vos données notamment lorsque
            ces données ont fait l’objet d’un traitement illicite, ou que la
            finalité pour laquelle elles ont été collectées n’est plus
            d’actualité.
          </li>
          <li>
            <u>Droit à la limitation du traitement.</u>
            Vous avez le droit de restreindre le traitement de vos données
            personnelles dans certaines circonstances.
          </li>
          <li>
            <u>Droit à la portabilité des données.</u>
            Vous avez le droit de recevoir vos données personnelles dans un
            format structuré, courant et lisible par machine, et de les
            transférer à une autre structure si cela est techniquement
            réalisable.
          </li>
          <li>
            <u>Droit d’opposition.</u>
            Vous pouvez vous opposer à tout moment à un traitement de vos
            données personnelles pour des raisons tenant à votre situation
            particulière ou par exemple si vos données sont utilisées à des fins
            de protection.
          </li>
        </ul>
      </li>

      <h2 class="mt-5">6. Comment nous contacter :</h2>
      <li class="list-group-item">
        <p>
          Si vous avez d'autres questions ou préoccupations concernant ces
          politiques de confidentialité, veuillez nous contacter à l'adresse
          <a href="mailto:support@kinomap.com">support&#64;kinomap.com</a>
        </p>
      </li>
    </ul>
  </div>
</div>
